import { render, staticRenderFns } from "./Outsource.vue?vue&type=template&id=d06feefa"
import script from "./Outsource.vue?vue&type=script&lang=js"
export * from "./Outsource.vue?vue&type=script&lang=js"
import style0 from "./Outsource.vue?vue&type=style&index=0&id=d06feefa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports